export default __webpack_public_path__ + "static/media/faq-minus.ae5320d2.svg";